import { Component, Input, OnInit } from '@angular/core';
import { CancelCalculation } from '../../models/cancel-calculations.model';
import { Contract } from '../../models/contract.interface';
import { CancellationData } from 'src/app/modules/contracts/models/cancellation-data.model';

@Component({
  selector: 'app-print-quote-content',
  templateUrl: './print-quote-content.component.html',
  styleUrls: ['./print-quote-content.component.scss'],
})
export class PrintQuoteContentComponent implements OnInit {
  @Input() cancelQuote?: CancelCalculation;
  @Input() selectedContract?: Contract;
  @Input() cancellationData?: CancellationData;
  
  constructor() {}

  ngOnInit(): void {}
}
